export const MAX_FILENAME_LENGTH = 140

export const ARTICLE_TYPES = ['EdgeArticle', 'ReviewArticle', 'Perspective', 'Comment'] as const
